module.exports = __webpack_public_path__ + "img/login_bg.07a6d5bd.png";